export default "__VITE_ASSET__Iwc3vKTZ__"